














































import {Component, Emit, Prop, Ref, Vue} from 'vue-property-decorator'
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";
import AddParamDialog from "@/component/Thing/add-param-dialog.vue";
import EditParamDialog from "@/component/Thing/edit-param-dialog.vue";
import ParamProxy, {ProxyMode} from "@/module/thing/ParamProxy";
import ArrayUtil from "tools-ts/src/util/ArrayUtil";
import _ from 'lodash';
import berror from 'biz-ts/src/error/BizError';

@Component({
  components: {
    DataSpecsFormItems,
    AddParamDialog,
    EditParamDialog,
  },
})
export default class CudParamItems extends Vue {

  @Prop() addTitle!: string

  @Prop() editTitle!: string

  @Prop()
  private paramProxies!: Array<ParamProxy>

  private getParamProxies() {
    return this.paramProxies
  }

  @Ref()
  private addParamDialog!: AddParamDialog

  @Ref()
  private editParamDialog!: EditParamDialog

  @Emit()
  private change() {
    // ignore
  }

  private activeParamProxy: ParamProxy = {
    name: "",
    identifier: "",
    mode: ProxyMode.STD_PROXY,
    order: -1,
    required: false,
  }

  private getActiveParamProxy() {
    return this.activeParamProxy
  }

  private isBindProxy(proxy: ParamProxy) {
    return proxy.mode == ProxyMode.BIND_PROXY
  }

  private addParam(proxy: ParamProxy) {
    this.checkDuplicate(proxy)
    const proxies = _.concat(this.paramProxies, proxy)
    this.setParamProxies(proxies)
  }

  private editParam(proxy: ParamProxy) {
    const proxies =
        ArrayUtil.mergeById(this.paramProxies, it => it.identifier, proxy)
    this.setParamProxies(proxies)
  }

  private checkDuplicate(proxy: ParamProxy, proxies = this.paramProxies) {
    const exist = ArrayUtil.hasById(
        proxies,
        it => it.identifier,
        proxy.identifier
    )
    if (exist)
      berror(this.$translate('sentence.cannotAddParamRepeatedly') + `${proxy.identifier}`)
  }

  private openEditParamDialog(proxy: ParamProxy) {
    this.activeParamProxy = proxy
    this.editParamDialog.open()
  }

  private removeParam(identifier: string) {
    const proxies = _.filter(this.paramProxies, proxy => {
      return proxy.identifier != identifier
    })
    this.setParamProxies(proxies)
  }

  private setParamProxies(proxies: Array<ParamProxy>) {
    this.assignOrder(proxies)
    this.$emit('update:paramProxies', proxies)
    this.change()
  }

  private assignOrder(proxies: Array<ParamProxy>) {
    let orderCount = 0
    proxies.forEach(proxy => {
      proxy.order = ++orderCount
    })
  }
}
